import { render } from "./FpNewIcon.vue?vue&type=template&id=7b9e42a5"
import script from "./FpNewIcon.vue?vue&type=script&lang=js"
export * from "./FpNewIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__